import { Record } from 'immutable';

const EventCollisionMatchRecord = Record({
  createdBy: null,
  clientCompany: null,
  eventName: null,
  groupCode: null,
  startDate: null,
  endDate: null,
  property: null,
  eventMatchId: null
});

export class EventCollisionMatch extends EventCollisionMatchRecord {
  createdBy: string;
  clientCompany: string;
  eventName: string;
  groupCode: string;
  startDate: string;
  endDate: string;
  property: string;
  eventMatchId: string;
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/event-collision-match.ts